import services from '@/services/ascentiaServiceIndex'
import { ALERT_TYPE_CONSTS as ATC } from '../consts'

const state = {
  allAlertTypesByModule: [],
}

const getters = {}

const mutations = {
  [ATC.UPDATE_ALL_ALERT_TYPES_BY_MODULE]: (state, data) =>
    (state.allAlertTypesByModule = data),
}

const actions = {
  async [ATC.GET_ALL_ALERT_TYPES_BY_MODULE](
    { commit },
    { id, isAdmin = false },
  ) {
    try {
      const response = await services.alertType.getData(
        'allAlertTypesByModule',
        { analyticModuleId: id, admin: isAdmin },
        true,
      )
      const data = response.data
      commit(ATC.UPDATE_ALL_ALERT_TYPES_BY_MODULE, data)
    } catch (error) {
      console.log(`${[ATC.GET_ALL_ALERT_TYPES_BY_MODULE]}: error ${error}`)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async [ATC.SAVE_ALERT_TYPE]({ commit }, alert) {
    try {
      await services.alertType.saveData('saveAlertType', alert)
    } catch (error) {
      console.log(`${[ATC.SAVE_ALERT_TYPE]}: error ${error}`)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
